import {type IconDefinition} from '@fortawesome/fontawesome-svg-core'
export default {
    'calendar-days': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faCalendarDays" */
        '@fortawesome/free-regular-svg-icons/faCalendarDays'
    ),
    'caret-square-down': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faSquareCaretDown" */
        '@fortawesome/free-regular-svg-icons/faSquareCaretDown'
    ),
    'circle-check': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faCircleCheck" */
        '@fortawesome/free-regular-svg-icons/faCircleCheck'
    ),
    'circle-play': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faPlayCircle" */
        '@fortawesome/free-regular-svg-icons/faPlayCircle'
    ),
    'circle-user': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faUserCircle" */
        '@fortawesome/free-regular-svg-icons/faUserCircle'
    ),
    'face-grin-beam': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faGrinBeam" */
        '@fortawesome/free-regular-svg-icons/faGrinBeam'
    ),
    'face-grin-beam-sweat': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faGrinBeamSweat" */
        '@fortawesome/free-regular-svg-icons/faGrinBeamSweat'
    ),
    'face-grin-tears': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faGrinTears" */
        '@fortawesome/free-regular-svg-icons/faGrinTears'
    ),
    'file-powerpoint': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faFilePowerpoint" */
        '@fortawesome/free-regular-svg-icons/faFilePowerpoint'
    ),
    'futbol': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faSoccerBall" */
        '@fortawesome/free-regular-svg-icons/faSoccerBall'
    ),
    'grin-tears': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faGrinTears" */
        '@fortawesome/free-regular-svg-icons/faGrinTears'
    ),
    'grin-tongue': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faGrinTongue" */
        '@fortawesome/free-regular-svg-icons/faGrinTongue'
    ),
    'image': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faImage" */
        '@fortawesome/free-regular-svg-icons/faImage'
    ),
    'message': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faMessage" */
        '@fortawesome/free-regular-svg-icons/faMessage'
    ),
    'object-ungroup': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faObjectUngroup" */
        '@fortawesome/free-regular-svg-icons/faObjectUngroup'
    ),
    'pause-circle': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faPauseCircle" */
        '@fortawesome/free-regular-svg-icons/faPauseCircle'
    ),
    'pen-to-square': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faPenToSquare" */
        '@fortawesome/free-regular-svg-icons/faPenToSquare'
    ),
    'sad-cry': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faSadCry" */
        '@fortawesome/free-regular-svg-icons/faSadCry'
    ),
    'square-full': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faSquareFull" */
        '@fortawesome/free-regular-svg-icons/faSquareFull'
    ),
    'star-half': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faStarHalf" */
        '@fortawesome/free-regular-svg-icons/faStarHalf'
    ),
} as Record<string, ()=>Promise<{ definition: IconDefinition }>>